interface AgentErrorFallbackProps {
  readonly agentName: string
  readonly error: unknown
  readonly storageKey: string
}

export function AgentErrorFallback({ agentName, error, storageKey }: AgentErrorFallbackProps) {
  return (
    <div className="h-screen flex items-center justify-center flex-col gap-4">
      <div className="text-error-500 text-xl font-semibold">Error al cargar {agentName}</div>
      <div className="text-sm text-gray-600 max-w-md text-center">
        {error instanceof Error ? error.message : 'Error desconocido'}
      </div>
      <button
        onClick={() => {
          sessionStorage.removeItem(storageKey)
          globalThis.location.reload()
        }}
        className="px-4 py-2 bg-info-500 text-white rounded hover:bg-info-600 transition-colors cursor-pointer"
      >
        Reintentar
      </button>
    </div>
  )
}
